// extracted by mini-css-extract-plugin
export default {"mobileToolbar":"general_mobileToolbar__4ON8n","toolbar":"general_toolbar__3pGPw","largeButton":"general_largeButton__Y7S4i","panelTitle":"general_panelTitle__8Agd6"};